export const COLUMN_TABLE_TEXTS = {
    METRICS_PLACEHOLDER: 'Metrics',
    SELECT_TITLE: 'Select any metric',
    SELECT_LABEL_SWITCH: 'Advanced',
};

export const COLUMN_TABLE_APPCUES_ID = {
    METRICS_SELECTOR: 'metric-selector',
};

export const COLUMN_TABLE_TEST_IDS = {
    MULTI_SELECTOR: 'multi-selector-single-value',
    CHECK_BOX: 'check-box-input',
    SWITCH_INPUT: 'switch-input',
    ADVANCED_METRIC: 'isAdvancedMetric',
};
